<div class="app-login-by-form" [class.app-login-by-form--ia-mode]="iaModeMobile.active()">
  @if (backgroudImageUrl()) {
  <div class="background-image">
    <img
      [src]="backgroudImageUrl()"
      alt="background"
      class="w-full h-full object-cover"
    />
  </div>
  } @if (isAccountConfirmed()) {
  <div class="success-confirm" role="alert">
    <aprova-icon
      class="success-confirm__icon"
      name="check-circle-solid"
      size="32px"
      color="#10B981"
    />
    <div class="success-confirm__content">
      <span class="success-confirm__title">Conta confirmada com sucesso!</span>
      <small class="success-confirm__subtitle">
        Agora basta efetuar seu login abaixo.
      </small>
    </div>
  </div>
  }
  <div class="app-login-by-form__content">
    @if(sessionTimeout()){
    <div
      class="border rounded-lg border-red-500 px-2 py-3 flex space-x-1 mb-11"
    >
      <aprova-icon
        [name]="'exclamation-circle-outline'"
        size="20px"
        [color]="'#EF4444'"
      />
      <div class="text-red-500 text-sm font-normal">
        Sua sessão expirou. Realize o login novamente.
      </div>
    </div>
    } @if (data$ | async; as data) { @if (!data.loading) {
    <div class="login-panel" [class.login-panel--ia-mode]="iaModeMobile.active()" [class.login-panel--govbr]="iaModeMobile.active() && showGovBrMethod(data.config)">
      <div class="box-login">
        @if (iaModeMobile.active()) {
        <h1 class="box-login__title box-login__title--ia-mode" data-testid="loginMessageContext">Entre para enviar e acompanhar seu pedido</h1>
        } @else {
        <span class="box-login__title">Acesse sua conta</span>
        }

        @if (!iaModeMobile.active() && showAuthMethod(data.config, 'CREDENTIALS') && !hideSignUp()) {
        <span class="box-login__subtitle">
          É seu primeiro acesso?
          <a (click)="redirectToCreateAccount()">Crie sua conta</a>
        </span>
        } @if (!iaModeMobile.active() && showGovBrAccountCreation(data.config)) {
        <span class="box-login__subtitle">
          É seu primeiro acesso?
          <a
            data-testid="loginLinkCreateAccountGovBr"
            (click)="createAccountWithGovBr(data.config)"
            >Crie sua conta</a
          >
        </span>
        } @if (!iaModeMobile.active() && showAuthMethod(data.config, 'CREDENTIALS') && subtitle()) {
        <span class="box-login__subtitle">{{ subtitle() }}</span>
        }
      </div>

      <!-- APR-4028 — no celular do IA mode os provedores (gov.br primeiro) vêm antes do e-mail e senha. -->
      @if (iaModeMobile.active()) {
      @if (hasAlternativeAuthMethods(data.config)) {
      <div class="alternative-logins">
        @if (showGovBrMethod(data.config)) {
        <ng-container [ngTemplateOutlet]="govBrLogin" />
        }
        @if (showBbMethod(data.config)) {
        <ng-container [ngTemplateOutlet]="bbLogin" />
        }
        @if (showAuthMethod(data.config, 'ICP')) {
        <ng-container [ngTemplateOutlet]="icpLogin" />
        }
        @if (showAuthMethod(data.config, 'GOOGLE')) {
        <ng-container [ngTemplateOutlet]="googleLogin" />
        }
        <ng-container [ngTemplateOutlet]="singleLoginInstructions" />
      </div>

      @if (showAuthMethod(data.config, 'CREDENTIALS')) {
      <div class="login-panel__divider">ou entre com {{ identifierConfig[identifierType].divider }}</div>
      }
      } @else if (showIntegrationLoginButton(data.config)) {
      <ng-container [ngTemplateOutlet]="integrationLogin" />
      }
      }

      @if (showAuthMethod(data.config, 'CREDENTIALS')) {
      <form class="login-form" [formGroup]="form" (submit)="onSubmit()">
        <div class="login-form__fields">
          <aprova-input
            #inputEmail
            id="email"
            [height]="iaModeMobile.active() ? '48px' : '44px'"
            inputClass="w-full px-[14px] py-[10px] text-base font-normal leading-[1.4] text-[#1C1C1C] focus:outline-none"
            labelClass="block text-sm font-medium leading-[1.4] text-[#1C1C1C]"
            [control]="form.controls.email"
            [label]="identifierConfig[identifierType].label"
            [placeholder]="identifierConfig[identifierType].placeholder"
            [mask]="identifierConfig[identifierType].mask"
            [required]="true"
            [errorMessages]="identifierConfig[identifierType].errorMessages"
            (input)="onFormInput()"
          />

          <aprova-input
            #inputPassword
            [inputType]="!showPassword() ? 'password' : 'text'"
            [height]="iaModeMobile.active() ? '48px' : '44px'"
            inputClass="w-full px-[14px] py-[10px] text-base font-normal leading-[1.4] text-[#1C1C1C] focus:outline-none"
            labelClass="block text-sm font-medium leading-[1.4] text-[#1C1C1C]"
            [control]="form.controls.password"
            label="Senha"
            [placeholder]="iaModeMobile.active() ? 'Sua senha' : 'Digite sua senha'"
            [required]="true"
            [errorMessages]="{
              required: 'Ops! Senha precisa ser preenchida.',
              incorrect: identifierConfig[identifierType].errorMessages.incorrect
            }"
            (input)="onFormInput()"
          >
            <ng-container append>
              @if (iaModeMobile.active()) {
              <button
                type="button"
                class="password-toggle"
                data-testid="loginButtonTogglePassword"
                [attr.aria-label]="showPassword() ? 'Ocultar senha' : 'Mostrar senha'"
                (click)="toggleInputPassword()"
              >
                <aprova-icon [name]="!showPassword() ? 'eye-off-solid' : 'eye-solid'" size="20px" color="#656666" />
              </button>
              } @else {
              <aprova-icon
                [name]="!showPassword() ? 'eye-off-solid' : 'eye-solid'"
                size="16px"
                color="#656666"
                class="cursor-pointer"
                (click)="toggleInputPassword()"
              />
              }
            </ng-container>
          </aprova-input>
        </div>

        <div class="login-form__actions" [class.login-form__actions--ia-mode]="iaModeMobile.active()">
          @if (!iaModeMobile.active()) {
          <label class="remember-me">
            <input
              type="checkbox"
              [checked]="rememberMe()"
              (change)="handleRemembermeChange()"
            />
            <span class="remember-me__checkmark"></span>
            <span class="remember-me__label">Lembrar de mim</span>
          </label>
          }

          @if (!hideRecoverPassword()) {
          <button
            type="button"
            class="forgot-password"
            (click)="redirectToRecoverPassword()"
          >
            Esqueci minha senha
          </button>
          }
        </div>

        @if (!data.config.hideRecaptcha) {
        <aprova-recaptcha
          [recaptchaFormControl]="form.controls.recaptchaReactive"
          horizontalPosition="center"
          [errorMessages]="{
            required: 'Esta opção é obrigatória para prosseguir.'
          }"
        />
        @if (!form.controls['recaptchaReactive'].errors &&
        !form.controls['recaptchaReactive'].pristine) {
        <div></div>
        } }

        <aprova-button
          id="btn-login-submit"
          buttonType="submit"
          buttonClass="h-12 rounded-xl bg-[#12949C] px-4 text-base font-medium leading-[1.4] text-white hover:bg-[#0f848b]"
          [disabled]="logginIn()"
          [isLoading]="logginIn()"
          [label]="logginIn() ? 'Carregando' : 'Entrar'"
        />
      </form>
      }

      @if (iaModeMobile.active()) {
      @if (showAuthMethod(data.config, 'CREDENTIALS') && !hideSignUp()) {
      <div class="login-panel__signup">
        <span>Ainda não tem conta?</span>
        <button type="button" data-testid="loginButtonCreateAccount" (click)="redirectToCreateAccount()">Criar conta</button>
      </div>
      } @else if (showGovBrAccountCreation(data.config)) {
      <div class="login-panel__signup">
        <span>Ainda não tem conta?</span>
        <button type="button" data-testid="loginLinkCreateAccountGovBr" (click)="createAccountWithGovBr(data.config)">Criar conta</button>
      </div>
      }
      } @else if (hasAlternativeAuthMethods(data.config)) {
      <div class="alternative-logins">
        @if (showAuthMethod(data.config, 'GOOGLE')) {
        <ng-container [ngTemplateOutlet]="googleLogin" />
        }

        @if (showBbMethod(data.config)) {
        <ng-container [ngTemplateOutlet]="bbLogin" />
        }

        @if (showGovBrMethod(data.config) || showAuthMethod(data.config, 'ICP')) {
        <div class="alternative-logins-actions">
          @if (showAuthMethod(data.config, 'ICP')) {
          <ng-container [ngTemplateOutlet]="icpLogin" />
          }

          @if (showGovBrMethod(data.config)) {
          <ng-container [ngTemplateOutlet]="govBrLogin" />
          }
        </div>
        }

        <ng-container [ngTemplateOutlet]="singleLoginInstructions" />
      </div>
      } @else if(showIntegrationLoginButton(data.config)) {
      <ng-container [ngTemplateOutlet]="integrationLogin" />
      }

      <ng-template #googleLogin>
        <div class="google-login-trigger">
          <div class="google-login-trigger__native">
            <aprova-google-button
              [width]="310"
              (signIn)="socialLogin($event)"
            ></aprova-google-button>
          </div>
          <div class="google-login-trigger__content" aria-hidden="true">
            <img src="/assets/images/google-logo.svg" alt="" />
            <span>Fazer login com o Google</span>
          </div>
        </div>
      </ng-template>

      <ng-template #bbLogin>
        <button
          id="btn-login-bb"
          data-testid="loginButtonBb"
          type="button"
          class="bb-signin-button"
          (click)="loginBb(data.config)"
        >
          Entrar com o&nbsp;<b>BB</b>
        </button>
      </ng-template>

      <ng-template #icpLogin>
        <button
          id="btn-login-icp"
          data-testid="loginButtonIcp"
          type="button"
          class="alternative-button alternative-button--compact"
          (click)="loginICP()"
        >
          <img src="/assets/images/icp-brasil.svg" alt="ICP Brasil" />
        </button>
      </ng-template>

      <ng-template #govBrLogin>
        <button
          id="btn-login-govbr"
          data-testid="loginButtonGovBr"
          type="button"
          class="govbr-signin-button"
          (click)="loginGovBr(data.config)"
        >
          Entrar com&nbsp;<b>gov.br</b>
        </button>
      </ng-template>

      <ng-template #singleLoginInstructions>
        <div
          class="single-login-instructions"
          [innerHTML]="showSingleLoginInstructions(data.config)"
        ></div>
      </ng-template>

      <ng-template #integrationLogin>
        <div class="integration-login">
          <aprova-button
            id="btn-login-integration"
            buttonType="button"
            buttonClass="h-12 rounded-xl bg-[#12949C] px-4 text-base font-medium leading-[1.4] text-white hover:bg-[#0f848b]"
            class="w-full"
            [label]="loginButtonText(data.config)"
            (click)="redirectToIntegrationUrl(data.config)"
          />

          @if(showIntegrationLoginButton(data.config)) {
          <div class="external-login-url-label">
            Digite ou copie o endereço e abra em seu navegador:
          </div>

          <div class="integration-login__url-row">
            <div class="external-login-url">
              {{ integrationMethodUrl(data.config) }}
            </div>
            <div class="external-login-url-copy">
              @if (urlCopied()) {
              <aprova-icon name="check-solid" size="20px" color="#1AAF50" />
              } @else {
              <aprova-icon
                name="document-duplicate-outline"
                size="20px"
                color="#9ca3af"
                class="cursor-pointer"
                (click)="copyIntegrationMethodUrl(data.config)"
              />
              }
            </div>
          </div>
          }
        </div>
      </ng-template>
    </div>
    } }
  </div>
</div>
